const modulesFiles = require.context("./api", true, /\.js$/);
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const value = modulesFiles(modulePath);
  modules = Object.assign(modules, value);
  return modules;
}, {});
export default modules;



// WEBPACK FOOTER //
// ./src/api/index.js